import axios from "axios";

import {
  callWithRetryGuard
} from "../components/utils/RetryManager";
import {
  NEA_WORKFLOW
} from "../constants/NeaWorkflow";

import {
  setNeaWorkflow
} from "../service/JweSession";

const {
  REACT_APP_INFO_API_URL,
  REACT_APP_LOGOUT_API_URL,
  REACT_APP_LEGACY_LOGIN_PAGE,
  REACT_APP_LEGACY_RETURN_URL,
  REACT_APP_LEGACY_SUIVI_DEM_RETURN_URL,
  REACT_APP_PARAM_CC_APP_API_URL,
  REACT_APP_JUSTIFICATIF_CHECK_REQUIS_API_URL,
  REACT_APP_SAVE_DEM_APP_API_URL,
  REACT_APP_EDIT_CLD_DTO,
  REACT_APP_UPDATE_EDITED_DEM,
  REACT_APP_UPDATE_DEM,
  REACT_APP_IS_DEMANDE_EN_COURS_URL,
  REACT_APP_TEST_CODE_PAYS_APP_API_URL
} = process.env;


export class ChequeCultureService {

  getUsagerInfo() {
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };    
    return axios(REACT_APP_INFO_API_URL, 
      
    {
      headers: header,
      withCredentials: 'omit'
    }
    
    );
  }

  logOut() {
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    return axios.get(REACT_APP_LOGOUT_API_URL,{
        headers: header,
        withCredentials: 'omit'

    });
  }

  redirectEaLegacy() {
    window.location.assign(REACT_APP_LEGACY_RETURN_URL);
  }

  redirectLoginEaLegacy() {
    window.location.assign(REACT_APP_LEGACY_LOGIN_PAGE);
  }

  redirectEaLegacyAccueil() {
    window.location.assign(REACT_APP_LEGACY_RETURN_URL);
  }

  redirectEaLegacySuiviDemandes() {
    return window.location.assign(REACT_APP_LEGACY_SUIVI_DEM_RETURN_URL);
  }

  getParamChequeCulture(codeDeleg) {
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    return axios.get(REACT_APP_PARAM_CC_APP_API_URL, {
      params: {
        codeDelegation: codeDeleg,
      },

        headers: header,
        withCredentials: 'omit'

    });
  }
  getJustificatifRequis() {
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    return axios.get(REACT_APP_JUSTIFICATIF_CHECK_REQUIS_API_URL,{
      headers: header,
      withCredentials: 'omit'
    }
    );
  }

  testPays(demande) {
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    return axios.post(REACT_APP_TEST_CODE_PAYS_APP_API_URL, demande,{
      headers: header,
      withCredentials: 'omit'
    });
  }

  submitDemandeForm(demande) {
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    setNeaWorkflow(NEA_WORKFLOW.DEMANDE_CREATE);
    try {
      const formJson = demande?.demandeDetails?.[0]?.formJson;

      const parsedFormJson = JSON.parse(formJson);

      const containsInvalidValue = (value) => {
        if (value === undefined) return true;

        if (typeof value === 'number' && Number.isNaN(value)) {
          return true;
        }

        if (typeof value === 'string' && value.toUpperCase() === 'NAN') {
          return true;
        }

        if (Array.isArray(value)) {
          return value.some(containsInvalidValue);
        }

        if (value !== null && typeof value === 'object') {
          return Object.values(value).some(containsInvalidValue);
        }

        return false;
      };

      if (containsInvalidValue(parsedFormJson)) {
        throw new Error('formJson contains invalid values');
      }

      return axios.post(
          REACT_APP_SAVE_DEM_APP_API_URL,
          demande,
          {
            headers: header,
            withCredentials: 'omit'
          }
      );

    } catch (error) {

      // Display error
      const retry = window.confirm(
          'Un problème est survenu lors de l\'envoi de votre demande de prestation.\n\n' +
          'Cliquez sur OK pour recharger le formulaire.'
      );

      if (retry) {
        window.history.back();
      }

      // Keep the error available to the caller if needed
      return Promise.reject(error);
    }
  }

  submitEditedForm(demande) {
    setNeaWorkflow(NEA_WORKFLOW.DEMANDE_UPDATE);
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    return axios.post(REACT_APP_UPDATE_DEM, demande,{
      headers: header,
      withCredentials: 'omit'
    });
  }

  getEditDto() {
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    return axios.get(REACT_APP_EDIT_CLD_DTO,{
      headers: header,
      withCredentials: 'omit'
    });
  }

  submitUpdatedDemande(Id) {
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    setNeaWorkflow(NEA_WORKFLOW.DEMANDE_UPDATE);
    return axios.get(REACT_APP_UPDATE_EDITED_DEM, {
      params: {
        demandeId: Id,
      },
      headers: header,
      withCredentials: 'omit'
    });
  }

  isDemandeEnCours(numCgos,codeCas) {

   const header = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': 'true',
      };
      return axios.get(REACT_APP_IS_DEMANDE_EN_COURS_URL, {
        params: {
          numCgos: numCgos,
          codeCas:codeCas
        },

          headers: header,
          withCredentials: 'omit'

      });

  }


  async submitDemandeGuarded (demande) {

      return callWithRetryGuard(demande.numeroCGOS,() =>
      this.submitDemandeForm(demande)
    );
  };


}
